import ApiService from "@/core/services/api.service";

const url = process.env.VUE_APP_API_ADMIN;

/**
 * Fetches a single sales channel from the backend, which proxies the Xentral
 * SalesChannelView API request. Used to check whether a (legacy) sales channel
 * is still active before enabling the connect-amazon receipt feature.
 */
export default {
  get(uuid) {
    return ApiService.get(url, "apps/salesChannels/" + uuid);
  }
};

/**
 * Checks whether the legacy Amazon shopimporter still has its invoice
 * service enabled. Only relevant for "shopimporter_amazon" channels — other
 * module types cannot conflict with the connect-amazon receipt feature.
 * Fails closed: an Amazon channel without the invoice handling explicitly
 * set to "none_amainvoice" counts as active.
 *
 * @param {object} payload flat channel config from GET /apps/salesChannels/{uuid}
 * @returns {boolean}
 */
export function isLegacyInvoiceServiceActive(payload) {
  if (payload?.modulename !== "shopimporter_amazon") {
    return false;
  }

  return (
    payload?.einstellungen_json?.felder?.invoice_handling_service !==
    "none_amainvoice"
  );
}
